import { render, staticRenderFns } from "./workQuestionList.vue?vue&type=template&id=ca920d6a&scoped=true&"
import script from "./workQuestionList.vue?vue&type=script&lang=js&"
export * from "./workQuestionList.vue?vue&type=script&lang=js&"
import style0 from "./workQuestionList.vue?vue&type=style&index=0&id=ca920d6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca920d6a",
  null
  
)

export default component.exports